const ProjectModel = [
    {
        name:"SLMS | Simple Loan Management System",
        link:"https://lms-sk.netlify.app",
        img:"project/LMS.jpg",
        Description:"Manage your client's finance in LMS. Gnerate invoices. Calculate Interests.",
        source:{
            front:"https://github.com/sathishwebdev/lms",
            back:"https://github.com/sathishwebdev/api.lms",
        }
    },
    {
        name:"Linkru",
        link:"https://linkru.netlify.app/",
        img:"project/linkru.jpg",
        Description:"Linkru is a web app which is instagram bio-link tool. Bloggers can use this to share their links by Linkru Profile. In futher updates, users can update sitemaps of their blogs which gonna be auto update their posts.",
        source:{
            front: "https://github.com/sathishwebdev/linkstore",
            back:"https://github.com/sathishwebdev/api.linkstore"
        }
    },
    {
        name: "Bubloo",
        link : "https://bubloo2716.web.app",
        img: "project/bubloo.jpg",
        Description:"The web app is created with React js framework and Firebase Real Time Database. In this App we can create a public chat room for group chat and also can do private chit-chat. This Project helps me to learn more about array and react js framework along with firebase. At first this project had firestore but due to usage limitations in firestore, i did with firebase database.",
        source:{
            front:"https://github.com/sathishwebdev/Bubloo-v2"
        }
    },
    {
        name: "Voofacts",
        link : "https://facts.sathishwebdev.com",
        img: "project/voofacts.jpg",
        Description: "This Project is works with Google Blogger. Just a blogger site which has some fun and interesting facts. In this project we provide custom domain called Voofacts.com that bought and configured in Godaddy. From this project we learn about Content Creation, SEO, Google analytics, Google Ads, Adsense, Search console and How to maintain a Blog.",
        source:{ front: "https://github.com/sathishwebdev/voofacts"}
    },   
    {
        name: "Tic-Tac-Toe",
        link : "https://tictactoe.sathishwebdev.com",
        img: "project/tic-tac-toe.jpg",
        Description:"Tic-Tac-Toe is game that we all play in our bored college days with pen and paper. I createed that as web app which start with Toss and maintain a scoreboard till refresh or restart the game.",
        source :{front : "https://github.com/sathishwebdev/tic-tac-toe"}
    }
   
]

export default ProjectModel


    // {
    //     name:"Shorty",
    //     link:"https://shorty-sk.netlify.app/",
    //     img: "project/shorty.jpg",
    //     Description:"Shorty is a URL shortner which shrink your long urls and give you some analytics by sharing short url. This Shortner has complete authentication process and anlaytics which has to update,now only views can be calculated.",
    //     source:{
    //         front: "https://github.com/sathishwebdev/url-shortner",
    //         back:"https://github.com/sathishwebdev/api.shorty"
    //     }
    // } 